<div class="filters">

    <div class="row chip-container">
        <icc-chip [focusable]="false" (click)="onListClick()" [class.icc-chip-elevated]="!isShowMap" class="icc-assist-chip"><icc-icon name="list"></icc-icon>{{ 'INTERFACE|Lista' | translate }}</icc-chip>
        <icc-chip [focusable]="false" (click)="onMapClick()" [class.icc-chip-elevated]="isShowMap" class="icc-assist-chip"><icc-icon name="view_map"></icc-icon>{{ 'INTERFACE|Mapa' | translate }}</icc-chip>
    </div>

    <div class="filters__name">{{ 'INTERFACE|Filtry' | translate }}</div>

    <button iccButton class="assigned-to-me" appearance="inverted"(click)="assignedToMe()"><icc-icon name="person"></icc-icon>{{ 'COMPLAINT|Przypisane do mnie' | translate }}</button>

    <div class="filters__filter">

        <div class="filters__filter__name">{{ 'COMPLAINT|Przypisana osoba' | translate }}</div>

        <div class="row" >

            <icc-select
                name="authorUserId"
                [value]="assignedUserId"
                (valueChange)="handleWorkers($event)"
            >
                <option [value]="0">{{ 'INTERFACE|Dowolny' | translate }}</option>
                <option
                    *ngFor="let worker of workersList | keyvalue"
                    value="{{worker.key}}"
                    [selected]="worker.key == assignedUserId"
                  >
                    {{worker.value}}
                </option>
            </icc-select>

        </div>

    </div>

    <div class="filters__filter">

        <div class="filters__filter__name">{{ 'COMPLAINT|Podmiot przypisany' | translate }}</div>

        <div class="row" >
            <ng-select
                autocomplete="off"
                [(ngModel)]="userTypeCompanyId"
                [ngModelOptions]="{standalone: true}"
                [virtualScroll]="true"
                [searchable]="true"
                [notFoundText]="'INTERFACE|Brak wyników' | translate"
                (change)="handleContractor($event)"
            >
                <ng-option [value]="0">{{ 'INTERFACE|Dowolny' | translate }}</ng-option>
                <ng-option *ngFor="let contractor of filteredContractorsList" [value]="contractor.companyId">{{getUserTypeName(contractor.userType)}} {{contractor.companyName}}</ng-option>
            </ng-select>

        </div>

    </div>

    <div class="filters__filter">

      <div class="filters__filter__name">{{ 'COMPLAINT|Klient' | translate }}</div>

      <div class="row" >

        <icc-input
            type="text"
            name="client"
            [value]="client"
            (valueChange)="client = $event"
            [supportText]="'COMPLAINT|Imię, nazwisko, email, telefon' | translate"
        ></icc-input>

      </div>

    </div>

    <div class="filters__filter">

      <div class="filters__filter__name">{{ 'COMPLAINT|Numer zgłoszenia / zamówienia' | translate }}</div>

      <div class="row" >

        <icc-input
            type="text"
            name="nrOrder"
            [value]="nrOrder"
            (valueChange)="nrOrder = $event"
        ></icc-input>

      </div>

    </div>

    <div *ngIf="userType === 'distributor' || userType === 'manufacturer'" class="filters__filter">

        <div *ngIf="userType === 'distributor'" class="filters__filter__name">{{ 'COMPLAINT|Sprzedający (APS)' | translate }}</div>
        <div *ngIf="userType === 'manufacturer'" class="filters__filter__name">{{ 'COMPLAINT|Sprzedający (Dystrybutor/APS)' | translate }}</div>

        <div class="row" >

            <ng-select
                autocomplete="off"
                [(ngModel)]="companyId"
                [ngModelOptions]="{standalone: true}"
                [virtualScroll]="true"
                [searchable]="true"
                [notFoundText]="'INTERFACE|Brak wyników' | translate"
                (change)="handleCompanyId($event)"
            >
                <ng-option [value]="0">{{ 'INTERFACE|Dowolny' | translate }}</ng-option>
                <ng-option *ngFor="let contractor of filteredContractors" [value]="contractor.companyId">{{getUserTypeName(contractor.userType)}} {{contractor.companyName}}</ng-option>
            </ng-select>

        </div>

    </div>

    <div class="filters__filter__name">{{ 'COMPLAINT|Status' | translate }}</div>

    <div class="row" >

        <icc-select
            (valueChange)="onStatusChange($event)"
            [value]="status"
        >
            <option [value]="-2">{{ 'COMPLAINT|Dowolny' | translate }}</option>
            <option [value]="0">{{ 'COMPLAINT|Dowolny otwarty' | translate }}</option>
            <option [value]="-1">{{ 'COMPLAINT|Dowolny zamknięty' | translate }}</option>
            <optgroup [label]="('COMPLAINT|Status producenta' | translate) + ' - ' + ('COMPLAINT|Zgłoszenia reklamacyjne' | translate)">
                <ng-container *ngFor="let documentStatus of documentStatuses">
                    <option *ngIf="+documentStatus.documentTypeId === 10 && documentStatus.complaintHandlingLevel === 'manufacturer'" [value]="documentStatus.id" [selected]="documentStatus.id === status">{{documentStatus.name}}</option>
                </ng-container>
            </optgroup>
            <optgroup [label]="('COMPLAINT|Status dystrybutora' | translate) + ' - ' + ('COMPLAINT|Zgłoszenia reklamacyjne' | translate)">
                <ng-container *ngFor="let documentStatus of documentStatuses">
                    <option *ngIf="+documentStatus.documentTypeId === 10 && documentStatus.complaintHandlingLevel === 'distributor'" [value]="documentStatus.id" [selected]="documentStatus.id === status">{{documentStatus.name}}</option>
                </ng-container>
            </optgroup>
            <optgroup [label]="('COMPLAINT|Status APS' | translate) + ' - ' + ('COMPLAINT|Zgłoszenia reklamacyjne' | translate)">
                <ng-container *ngFor="let documentStatus of documentStatuses">
                    <option *ngIf="+documentStatus.documentTypeId === 10 && documentStatus.complaintHandlingLevel === 'authorizedRetailer'" [value]="documentStatus.id" [selected]="documentStatus.id === status">{{documentStatus.name}}</option>
                </ng-container>
            </optgroup>
            <optgroup [label]="('COMPLAINT|Status producenta' | translate) + ' - ' + ('COMPLAINT|Zgłoszenia płatne' | translate)">
                <ng-container *ngFor="let documentStatus of documentStatuses">
                    <option *ngIf="+documentStatus.documentTypeId === 11 && documentStatus.complaintHandlingLevel === 'manufacturer'" [value]="documentStatus.id" [selected]="documentStatus.id === status">{{documentStatus.name}}</option>
                </ng-container>
            </optgroup>
            <optgroup [label]="('COMPLAINT|Status dystrybutora' | translate) + ' - ' + ('COMPLAINT|Zgłoszenia płatne' | translate)">
                <ng-container *ngFor="let documentStatus of documentStatuses">
                    <option *ngIf="+documentStatus.documentTypeId === 11 && documentStatus.complaintHandlingLevel === 'distributor'" [value]="documentStatus.id" [selected]="documentStatus.id === status">{{documentStatus.name}}</option>
                </ng-container>
            </optgroup>
            <optgroup [label]="('COMPLAINT|Status APS' | translate) + ' - ' + ('COMPLAINT|Zgłoszenia płatne' | translate)">
                <ng-container *ngFor="let documentStatus of documentStatuses">
                    <option *ngIf="+documentStatus.documentTypeId === 11 && documentStatus.complaintHandlingLevel === 'authorizedRetailer'" [value]="documentStatus.id" [selected]="documentStatus.id === status">{{documentStatus.name}}</option>
                </ng-container>
            </optgroup>
        </icc-select>

    </div>

    <ng-container *ngIf="availableComplaintTypes.length > 1">

        <div class="filters__filter__name">{{ 'COMPLAINT|Typ zgłoszenia' | translate }}</div>

        <div class="row" >

            <icc-select
                (valueChange)="onComplaintTypeChange($event)"
                [value]="complaintType"
            >
                <option *ngFor="let type of availableComplaintTypes" [value]="type.value">
                    {{ type.label | translate }}
                </option>
            </icc-select>

        </div>

    </ng-container>

    <div class="filters__filter" *ngIf="userType === 'manufacturer'">

        <div class="filters__filter__name">{{ 'COMPLAINT|Region' | translate }}</div>

        <div class="row" >

            <icc-select
                name="accountManagerPersonId"
                [value]="accountManagerPersonId"
                (valueChange)="handleAccountManager($event)"
            >
                <option [value]="0">{{ 'INTERFACE|Dowolny' | translate }}</option>
                <option
                    *ngFor="let worker of accountManagersList | keyvalue"
                    value="{{worker.key}}"
                    [selected]="worker.key == accountManagerPersonId"
                  >
                    {{worker.value}}
                </option>
            </icc-select>

        </div>

    </div>

    <div class="filters__filter">

      <div class="filters__filter__name">{{ 'COMPLAINT|Data utworzenia zgłoszenia' | translate }}</div>

      <div class="row" >

        <icc-form-field
          size="small"
        >
            <label iccLabel>{{ 'INTERFACE|Od' | translate }}</label>
            <icc-input
                type="date"
                name="date"
                [value]="creationDateFrom"
                (valueChange)="creationDateFrom =$event"
            >
            </icc-input>

        </icc-form-field>

      </div>

      <div class="row" >

        <icc-form-field
          size="small"
        >
          <label iccLabel>{{ 'INTERFACE|Do' | translate }}</label>
          <icc-input
              type="date"
              [value]="creationDateTo"
              (valueChange)="creationDateTo = $event"

          >
          </icc-input>

        </icc-form-field>

      </div>

    </div>

    <div class="filters__actions">
        <div class="row">
            <button iccButton appearance="secondary" (click)="emitFilters()">
                {{ 'INTERFACE|Filtruj' | translate }} <icc-icon name="navigate_next"></icc-icon>
            </button>
        </div>

        <div class="row">
            <button iccButton appearance="outline" (click)="resetFilters()">
                {{ 'INTERFACE|Resetuj' | translate }}  <icc-icon name="navigate_before"></icc-icon>
            </button>
        </div>
    </div>



  </div>

